import requests from './request'

export const getUserInfo = () => requests.get('/cas/userinfo')

export const updatePassword = (data) => requests.post('/cas/change-password', data)

export const bindEmail = (data) => requests.post('/cas/bind-email', data)

export const bindPhone = (data) => requests.post('/cas/bind-phone', data)

export const getEmailCode = (data) => requests.post('/cas/send-email-code', data)

export const getPhoneCode = (data) => requests.post('/cas/send-phone-code', data)